'use strict';

var NAME           = 'autocomplete-ajax';
var NAMESPACE      = 'hogo.' + NAME;
var SELECTOR       = '[data-' + NAME + ']';

var $body = $(document.body);


/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
const AutocompleteAjax = function (el, options) {
    this.$input = $(el);
    this.$container = this.$input.closest('.input-field');
    this.$autocomplete = $('<ul class="autocomplete-content dropdown-content" data-constrainwidth="false"></ul>');

    this.options = options;
    this.data = this.options.data;

    this.value = '';

    this.activeIndex = 0;

    if (this.$container.length) {
        this.$container.append(this.$autocomplete);
    } else {
        this.$input.after(this.$autocomplete);
    }

    this.bindEvents();
};

/**
 * Autocomplete version.
 */
AutocompleteAjax.VERSION = '0.1.0';

/**
 * Autocomplete component defaults.
 */
AutocompleteAjax.DEFAULTS = {
    data: {},
    ajax: {},
    callback: $.noop(),
    delay: null,
    minLength: 2,
    autocomplete_id: null,
    input_name: null
};

/**
 * Highlights the search text inside individual items.
 *
 * @param  {String}  string
 */
AutocompleteAjax.prototype.highlight = function (string)
{
    var matchStart = string.toLowerCase().indexOf('' + this.value.toLowerCase() + '');

    if (matchStart === -1) {
        return string;
    }

    var matchEnd = matchStart + this.value.length - 1,
        beforeMatch = string.slice(0, matchStart),
        matchText = string.slice(matchStart, matchEnd + 1),
        afterMatch = string.slice(matchEnd + 1);

    return beforeMatch + '<span class="highlight">' + matchText + '</span>' + afterMatch;
};

/**
 * Displays the autocomplete container.
 */
AutocompleteAjax.prototype.show = function ()
{
    this.$autocomplete.show();
};

/**
 * Hides the autocomplete container.
 */
AutocompleteAjax.prototype.hide = function ()
{
    this.$autocomplete.hide();
};

/**
 * Add a single item to the autocomplete container.
 *
 * @param  {String}  name
 * @param  {String}  value
 */
AutocompleteAjax.prototype.addItem = function (name, value)
{
    this.$autocomplete.append('<li><a href="' + value + '">' + this.highlight(name) + '</a></li>');
};

/**
 * Add several new items to the autocomplete container.
 *
 * {
 *     "Item Name": "http://itemurl.example/",
 *     "Item Name 2": "http://itemurl.example/",
 *     "Item Name 3": "http://itemurl.example/"
 * }
 *
 * @param  {Object}  items
 */
AutocompleteAjax.prototype.addItems = function (items)
{
    for (var key in items) {
        this.addItem(key, items[key]);
    }
};

/**
 * Binds all of the required events.
 */
AutocompleteAjax.prototype.bindEvents = function ()
{
    this.$autocomplete.on(
        'mousedown.' + NAMESPACE +
        ' touchstart.' + NAMESPACE, 'li', $.proxy(this.handleMouseDown, this));

    this.$input.on('keyup.' + NAMESPACE, $.proxy(this.handleKeyUp, this));
    this.$input.on('keydown.' + NAMESPACE, $.proxy(this.handleKeyDown, this));
    this.$input.on('focus.' + NAMESPACE, $.proxy(this.handleFocus, this));
    this.$input.on('blur.' + NAMESPACE, $.proxy(this.handleBlur, this));
};

/**
 * Reset the autocomplete component.
 */
AutocompleteAjax.prototype.reset = function ()
{
    this.$autocomplete.empty();
    this.activeIndex = 0;
};

/**
 * Returns the currently active item.
 *
 * @return  {Object}
 */
AutocompleteAjax.prototype.getActiveItem = function ()
{
    return this.$autocomplete.children('li').eq(this.activeIndex);
}
/**
 * Sets the current active item to the index passed.
 *
 * @param  {Number}  index
 */
AutocompleteAjax.prototype.setActiveItem = function (index)
{
    this.activeIndex = index;
    this.$autocomplete.children('.active').removeClass('active');
    this.getActiveItem().addClass('active');

    // Autoscroll
    var autocompleteTop = this.$autocomplete.scrollTop(),
        autocompleteBottom = autocompleteTop + this.$autocomplete.height(),
        itemTop = autocompleteTop + this.getActiveItem().position().top,
        itemHeight = this.getActiveItem().height(),
        itemBottom = itemTop + itemHeight;

    if (itemBottom > autocompleteBottom) {
        console.log(this.$autocomplete.height());
        this.$autocomplete.scrollTop(itemBottom - this.$autocomplete.height());
    } else if (itemTop < autocompleteTop) {
        this.$autocomplete.scrollTop(itemTop);
    }

};

/**
 * Fetch new data from the server.
 */
AutocompleteAjax.prototype.fetchData = function ()
{
    $.ajax($.extend({}, {
        url: '',
        method: 'get',
        dataType: 'json',
        data: {
            query: this.value
        },
        error: $.noop(),
        beforeSend: $.proxy(function (jqXHR, settings) {
            if (this.options.ajax.beforeSend) {
                this.options.ajax.beforeSend(jqXHR, settings);
            }
        }, this),
        success: $.proxy(function (response) {

            this.data = this.options.callback(response) || response;

            this.reset();
            if (this.hasData()) {
                this.addItems(this.data);
                this.setActiveItem(0);
                this.show();
            }

        }, this)

    }, this.options.ajax));

};

/**
 * Retrieves new data from the server based on the current value of the input
 * element.
 */
AutocompleteAjax.prototype.getData = function ()
{
    if (this.value.length < this.options.minLength) {
        this.reset();
        this.hide();
        return;
    }

    if (this.timer) {
        clearTimeout(this.timer);
    }

    this.timer = setTimeout($.proxy(this.fetchData, this), this.options.delay);
};

/**
 * Returns whether or not there is any data.
 */
AutocompleteAjax.prototype.hasData = function ()
{
    return ! $.isEmptyObject(this.data);
}

/**
 * Redirect to the passed location.
 *
 * @param  {String}  location
 */
AutocompleteAjax.prototype.redirectTo = function (location)
{
    window.location.href = location;
};

/**
 * Redirect the window to the current active item.
 */
AutocompleteAjax.prototype.redirectToActiveItem = function ()
{
    this.redirectTo(this.getActiveItem().children('a').attr('href'));
};

/**
 * Handles when an item is clicked on.
 *
 * @param  {Object}  e
 */
AutocompleteAjax.prototype.handleMouseDown = function (e)
{
    this.redirectTo($(e.target).closest('a').attr('href'));
};

/**
 * Handler for when the input element is focused.
 *
 * @param  {Object}  e
 */
AutocompleteAjax.prototype.handleFocus = function (e)
{
    this.show();
};

/**
 * Handler for when the input element is blurred.
 *
 * @param  {Object}  e
 */
AutocompleteAjax.prototype.handleBlur = function (e)
{
    this.hide();
};

/**
 * Handler for when a key is down on the input element.
 *
 * @param  {Object}  e
 */
AutocompleteAjax.prototype.handleKeyDown = function (e)
{
    switch(e.which) {
        case 13: // enter
            if (this.hasData()) {
                this.getActiveItem().addClass('pressed');
                this.redirectToActiveItem();
                return false;
            } else {
                return true;
            }

        case 38: // up
            e.preventDefault();
            if (this.activeIndex > 0) {
                this.setActiveItem(--this.activeIndex);
            }
            break;

        case 40: // down
            e.preventDefault();
            if (this.activeIndex < (this.$autocomplete.children().length - 1)) {
                this.setActiveItem(++this.activeIndex);
            }
            break;
    }

};

/**
 * Handler for when a key is up on the input element.
 *
 * @param  {Object}  e
 */
AutocompleteAjax.prototype.handleKeyUp = function (e)
{
    // Don't capture up/down/enter
    switch(e.which) {
        case 13: // enter
        case 38: // up
        case 40: // down
            return;
        case 27: // ESC
            this.reset();
            this.hide();
            break;
    }

    if (this.$input.val() !== this.value) {

        this.value = this.$input.val();

        this.getData();

    }
};


// AUTOCOMPLETE PLUGIN DEFINITION
// ==============================

function Plugin (option)
{
    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }

    return this.each(function () {
        var $this = $(this);
        var options = $.extend({}, AutocompleteAjax.DEFAULTS, $this.data(), typeof option == 'object' && option)

        var data  = $this.data(NAMESPACE);

        if ( ! data) $this.data(NAMESPACE, (data = new AutocompleteAjax(this, options)));
        if (typeof option === 'string') data[option].apply(data, args);
    });
}

$.fn.autocompleteAjax             = Plugin;
$.fn.autocompleteAjax.Constructor = AutocompleteAjax;


// APPLY TO STANDARD DATE SELECT ELEMENTS
// ======================================

$(SELECTOR).autocompleteAjax();



// EXPORT MODULE
// =============

export default AutocompleteAjax;